enum ABCA2AStatuses {
  'airport-preslot' = 1,
  'driver' = 2,
  'processing' = 3,
  'complete' = 4
}

export default ABCA2AStatuses;



// WEBPACK FOOTER //
// ./src/enum/ABC-A2A-status.enum.ts